var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gfu-layout__main gfu-layout__main--narrow _mt-6" },
    [
      _c(
        "h1",
        {
          staticClass: "gfu-heading gfu-heading--main",
          attrs: { "data-qa": "page-title" },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.Resources.Checkout.CheckoutHeader) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "gfu-subheading gfu-subheading--main" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.Resources.Checkout.CheckoutSubHeader) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "box",
        { staticClass: "_mt-3 _mb-6", attrs: { "data-qa": "cart-box" } },
        [
          _c("h2", { staticClass: "_sr-only" }, [
            _vm._v(_vm._s(_vm.Resources.Checkout.CheckoutProductsSectionTitle)),
          ]),
          _vm._v(" "),
          _c("cart-table", { attrs: { "order-id": _vm.currentOrderId } }),
          _vm._v(" "),
          _vm.isManageYourPledgeButtonVisible
            ? _c(
                "div",
                {
                  attrs: {
                    "data-qa": `begin-order-form-button:${_vm.checkoutReturnActionDataQa}`,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "gfu-1of1 gfu-1of2--s gfu-1of3--m" },
                    [
                      _c(
                        "base-button",
                        {
                          attrs: {
                            tag: "a",
                            href: _vm.checkoutReturnActionUrl,
                            shape: "default",
                            display: "block",
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.Resources.Checkout.ManageYourPledgeButton
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isOrderDetailsLocationVisible
            ? _c(
                "order-details-location",
                _vm._b(
                  {
                    on: {
                      "order-details-location-changed":
                        _vm.onOrderDetailsLocationChanged,
                    },
                  },
                  "order-details-location",
                  _vm.orderDetailsLocationProps,
                  false
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isShippingSelectionFormVisible
            ? _c("shipping-model-selection-form", {
                attrs: {
                  "shipping-models": _vm.shippingModels,
                  "shipping-model-id": _vm.shippingModel,
                  "handle-tax": _vm.handleTaxWithoutShipping,
                  "is-amending-shipping": _vm.isAmendingShipping,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("order-summary-list", {
            attrs: { "order-id": _vm.currentOrderId },
          }),
          _vm._v(" "),
          _vm.isOrderToPay
            ? _c(
                "h2",
                { staticClass: "gfu-heading gfu-heading--top-divider _mt-4" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.Resources.Checkout
                          .CheckoutPaymentOptionsSectionTitle
                      ) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isInitialized
            ? _c("dynamic-currency-conversion-wrapper", {
                attrs: {
                  "project-id": _vm.projectId,
                  "order-id": _vm.currentOrderId,
                  reason: _vm.paymentMethodsByOrderPaymentType,
                  "can-be-paid-in-installments": _vm.canBePaidInInstallments,
                  "handle-tax-without-shipping": _vm.handleTaxWithoutShipping,
                  "payment-currency-strategy": _vm.paymentCurrencyStrategy,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isPaymentTypesVisible
            ? _c("payment-types", {
                attrs: {
                  "current-payment-type": _vm.selectedPaymentType,
                  "checkout-mode": _vm.checkoutMode,
                  "effective-payable-amount": _vm.effectivePayableAmount,
                  "data-qa": "installments-wrapper",
                },
                on: { "payment-type-changed": _vm.onPaymentTypeChanged },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isOrderToPay
            ? _c("h3", { staticClass: "gfu-hd gfu-hd--h3 _mt-5" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.Resources.Checkout.CheckoutPaymentMethodSectionTitle
                    ) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isAdyenPaymentFormVisible
            ? _c(
                "adyen-order-payment-form",
                _vm._b(
                  { attrs: { "data-qa": "payment-section" } },
                  "adyen-order-payment-form",
                  _vm.paymentFormProps,
                  false
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isStripePaymentFormVisible
            ? _c(
                "stripe-payment-form",
                _vm._b(
                  { attrs: { "data-qa": "stripe-payment-form" } },
                  "stripe-payment-form",
                  _vm.paymentFormProps,
                  false
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _c("checkout-footer"),
          _vm._v(" "),
          _c("progress-overlay", { attrs: { visible: _vm.isProcessingView } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("project-context-modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }